import type { PatientPreset } from '../types/simulation';

/** Contrasting profiles: the same default start rarely fits all of them equally well. */
export const patients: PatientPreset[] = [
  { id: '01', age: 34, weight: 72, amh: 24, profile: 'average AMH / average weight' },
  { id: '02', age: 29, weight: 66, amh: 46, profile: 'higher AMH / average weight' },
  { id: '03', age: 38, weight: 68, amh: 7, profile: 'lower AMH / average weight' },
  { id: '04', age: 31, weight: 52, amh: 38, profile: 'higher AMH / lower weight' },
  { id: '05', age: 36, weight: 88, amh: 16, profile: 'lower AMH / higher weight' },
];
